const catToggle = {
  filterBtn: document.getElementById('jsFilterBtn') as HTMLElement,
  filterWrap: document.getElementById('jsFilterWrap') as HTMLElement,
  prodWrap: document.getElementById('jsProductWrap') as HTMLElement,
  items: document.querySelectorAll('.product-box') as NodeListOf<HTMLElement>,
  mainView: document.querySelector('.jsMainView') as HTMLElement,
  altView: document.querySelector('.jsAltView') as HTMLElement,

  init() {
    this.toggleFilter();
    this.toggleView();
  },

  toggleFilter() {
    if (this.filterBtn) {
      this.filterBtn.addEventListener('click', () => {
        this.filterBtn.classList.toggle('activeClass');
        this.filterWrap.classList.toggle('activeClass');
      });
    }
  },

  toggleView() {
    if (this.mainView) {
      this.mainView.addEventListener('click', () => {
        this.prodWrap.classList.add('activeClass');
        this.altView.classList.add('activeClass');
        this.mainView.classList.add('activeClass');

        this.items.forEach((box) => {
          box.classList.add('product-box--resized');
        });
      });
    }

    if (this.altView) {
      this.altView.addEventListener('click', () => {
        this.prodWrap.classList.remove('activeClass');
        this.altView.classList.remove('activeClass');
        this.mainView.classList.remove('activeClass');

        this.items.forEach((box) => {
          box.classList.remove('product-box--resized');
        });
      });
    }
  },
};

export default catToggle;
